
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTransformer02On as ObiTransformer02OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-transformer-02-on.js';
 
 
 

 
 export const ObiTransformer02On = createComponent({
   react: React,
   tagName: 'obi-transformer-02-on',
   elementClass: ObiTransformer02OnElement,
   events: {
     
   }
  });
 
 